import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d9sqsvllbrt1qcgaj8fg';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      return;
    }
    if (!email.trim()) return;

    setStatus('loading');
    try {
      const payload = new URLSearchParams();
      payload.append('email', email);
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch { /* ignore parse error */ }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请稍后重试');
      setStatus('error');
    }
  };

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="bg-accent-100/60 rounded-2xl p-10 md:p-14">
          <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-500 text-background-50 mb-6">
            <i className="ri-mail-send-line text-2xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            订阅我们的资讯
          </h2>
          <p className="mt-3 text-foreground-600 text-base max-w-md mx-auto">
            第一时间获取po18官网app最新小说推荐、活动资讯和使用技巧
          </p>

          {status === 'success' ? (
            <div className="mt-8 py-4 px-6 bg-accent-200/60 rounded-xl inline-block">
              <p className="text-foreground-800 font-medium">
                <i className="ri-checkbox-circle-line mr-2 text-accent-600"></i>
                订阅成功！感谢您的关注！
              </p>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              className="mt-8 flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
              data-readdy-form
              id="newsletter-form"
            >
              <div className="hp-field-wrapper">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="请输入您的邮箱地址"
                required
                className="w-full px-5 py-3.5 rounded-full bg-background-50 border border-background-300/60 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="whitespace-nowrap cursor-pointer w-full sm:w-auto bg-primary-500 text-background-50 px-8 py-3.5 rounded-full text-sm font-medium hover:bg-primary-600 disabled:opacity-60 transition-all duration-200"
              >
                {status === 'loading' ? '提交中...' : '立即订阅'}
              </button>
            </form>
          )}

          {status === 'error' && (
            <p className="mt-3 text-sm text-primary-600">{errorMsg}</p>
          )}

          <p className="mt-4 text-xs text-foreground-500">
            我们尊重您的隐私，不会发送垃圾邮件
          </p>
        </div>
      </div>
    </section>
  );
}